// extracted by mini-css-extract-plugin
export default {"customFields":"order-detail_customFields__7umVE","box":"order-detail_box__gNXHf","line":"order-detail_line__Dmx5M","field":"order-detail_field__glEGt"};